module.exports = __webpack_public_path__ + "static/media/zebra2_blue.1d92bd87.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zebra2_blue.svg
// module id = 571
// module chunks = 0